export const MAXIMUM_DESCRIPTION_LENGTH = 154
